module.exports = __webpack_public_path__ + "assets/img/img-tuxiang-bc3992f5.jpg";